import ExpensesTable from 'pages/expenses/ExpensesTable';
import { ClassifierData } from 'types/classifiers';
import { MatterDto } from 'types/matters.ts';

interface Props {
    matter: MatterDto;
    classifiers: Record<string, ClassifierData>;
}

const ExpensesView: React.FC<Props> = ({ matter }) => {
    return (
        <div className="flex h-full flex-col gap-4">
            <ExpensesTable matter={matter} disabledFilterIds={['matterIdInFilter', 'expenseClientFilter']} />
        </div>
    );
};

export default ExpensesView;
